import withTranslation from '../../../globals/components/withTranslation'
import Component from './component'
export default withTranslation(Component)
